<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEdit($event)">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="loading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>

        <el-table-column prop="type" label="类型"></el-table-column>

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="icon" label="ICON">
          <template #default="{ row }">
            <el-image
              :src="row.icon"
              :preview-src-list="[row.icon]"
              style="max-width: 50px; max-width: 50px"
            />
          </template>
        </el-table-column>

        <el-table-column prop="introduction" label="简介"></el-table-column>

        <el-table-column prop="sampleImageUrl" label="示例图片">
          <template #default="{ row }">
            <el-image
              v-if="row.sampleImageUrl"
              :src="row.sampleImageUrl"
              :preview-src-list="[row.sampleImageUrl]"
              style="max-width: 50px; max-width: 50px"
            />
          </template>
        </el-table-column>

        <el-table-column prop="bgImage" label="背景图">
          <template #default="{ row }">
            <el-image
              v-if="row.bgImage"
              :src="row.bgImage"
              :preview-src-list="[row.bgImage]"
              style="max-width: 50px; max-width: 50px"
            />
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间">
          <template #default="{ row }">{{ row.createTime | formatDate }}</template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty />
        </template>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      >
      </el-pagination>
    </div>

    <edit ref="editRef" @success="list" />
  </section>
</template>

<script>
import Edit from "./components/Edit";
import mainHeight from "@/utils/mainHeight";
export default {
  name: "AppraiseImageType",
  components: { Edit },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      loading: true,
      page: {},
      filters: {},
      selectedRows: [],
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.loading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/appraise-image-type/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.loading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleEdit(row) {
      if (row.id) {
        this.$refs.editRef.showEdit(row);
      } else {
        this.$refs.editRef.showEdit();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
